import httpClient from "Api/httpClient";

const END_POINT = "/log_templates";
const DETAIL_END_POINT = "/log_templates_detail";

const getLogTemplates = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getLogTemplate = (template_id) => {
    if (!template_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + template_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printLogTemplate = (template_id) => {
    if (!template_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?template_id=" + template_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createLogTemplates = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateLogTemplates = (payload, template_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + template_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteLogTemplates = (template_id) => {
    const DELETE_END_POINT = END_POINT + "/" + template_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

const createLogTemplateDetail = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(DETAIL_END_POINT, body);
};

const updateLogTemplateDetail = (payload, detail_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = DETAIL_END_POINT + "/" + detail_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteLogTemplateDetail = (detail_id) => {
    const DELETE_END_POINT = DETAIL_END_POINT + "/" + detail_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export {
    getLogTemplates,
    getLogTemplate,
    printLogTemplate,
    createLogTemplates,
    updateLogTemplates,
    deleteLogTemplates,
    createLogTemplateDetail,
    updateLogTemplateDetail,
    deleteLogTemplateDetail,
};
